import React from 'react'
import { Box, Container, Stack, Typography } from '@mui/material'
import { FormattedMessage } from 'react-intl'

interface ITextBlock {
  title: string
  description?: string
  bgImage: string
  children?: React.ReactNode
}

export default function BgImageTitleLayout(props: ITextBlock) {
  return (
    <Box sx={{ minHeight: 'calc(100dvh - 72px)' }}>
      <Stack
        sx={{
          backgroundImage: props.bgImage,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 400,
          height: '100%',
          px: { xs: 2, sm: 4 },
          pb: 10,
          position: 'relative'
        }}
      >
        <Box
          sx={{
            bottom: 0,
            left: 0,
            position: 'absolute',
            right: 0,
            background: 'linear-gradient(0deg, #181818, transparent)',
            height: '80%'
          }}
        />
        <Box sx={{ maxWidth: 600, zIndex: 1 }}>
          <Typography variant='h1'>
            <FormattedMessage id={props.title} />
          </Typography>
          {props.description && (
            <Typography variant='h6' sx={{ fontWeight: 400, mt: 1 }}>
              <FormattedMessage id={props.description} />
            </Typography>
          )}
        </Box>
      </Stack>
      {props.children && <Container sx={{ mt: -20, position: 'relative' }}>{props.children}</Container>}
    </Box>
  )
}
